import VerificationForm from "./verificationForm.container";

export default VerificationForm;